import React, {Component, Fragment} from "react";
import {Card, CardBody, Input} from "reactstrap";
import RegistrationCreationRequest from "../../../domain/Registration/RegistrationCreationRequest";
import * as yup from "yup";
import * as ValidationRule from "../../../utils/ValidationRule";
import InboundTransactionSearchService from "../../../services/Transaction/inbound/InboundTransactionSearchService";
import ToastHelper from "../../../utils/ToastHelper";
import "./InboundTransactionSearch.css";
import "./../Registerv2/RegisterV2.css";
import TransactingPartnerConfigService from "../../../services/TransactingPartnerConfigService";
import SFXButtonComponent from "../../../components/SFXButtonComponent";
import SikhonaLoadingComponent from "../../../components/SikhonaLoadingComponent/SikhonaLoadingComponent";
import InboundTransactionSearchContactUs from "./InboundTransactionSearchContactUs";
import {withRouter} from "react-router-dom";
import InboundTransactionService from "../../../services/Transaction/inbound/InboundTransactionService";
import SystemConfigService from "../../../services/SystemConfigService";
import ChatComponent from "../../../components/Chat/ChatComponent";

const TRANSACTION_SEARCH = "transaction_search";
const CUSTOMER_REGISTERED = "customer_registered";
const CANNOT_PROCESS_ORDER = "cannot_process_order";

const CHAT_ACTIVE_KEY = 'CUSTOMER_PORTAL_INBOUND_TRANSACTION_SEARCH_CHAT_ACTIVE'

class InboundTransactionSearch extends Component {
    constructor(props) {
        super(props);

        this.schema = RegistrationCreationRequest.retrieveNewRegistrationValidationConfig();

        this.baseUrl = this.props.baseUrl;
        this.remittancePartner = this.props.match.params.remittancePartner;

        this.state = {
            view: TRANSACTION_SEARCH,
            collectionPin: "",
            phoneNumber: "",

            touchedFields: {},
            inValidFields: {},
            validFields: {},

            loading: true,

            isFaded: false,

            toolTipOpen: false,

            isContactUsShowing: this.props.isContactUsShowing,

            isChatActive: false,

            isChatShowing: false,

            createConversationError: "",

            viewConversationError: ""
        };

        this.searchTransaction = this.searchTransaction.bind(this);
        this.isSearchDisabled = this.isSearchDisabled.bind(this);
        this.goHome = this.goHome.bind(this);
        this.retry = this.retry.bind(this);
    }

    componentDidMount() {
        let promises = [];

        let transactingPartnerConfigIndex = promises.length;
        promises[transactingPartnerConfigIndex] = TransactingPartnerConfigService.retrieveConfigByRemittancePartner(this.remittancePartner);

        let isChatActiveIndex = promises.length;
        promises[isChatActiveIndex] = SystemConfigService.retrieveConfigEntryUsingRegisteringPartnerCred(CHAT_ACTIVE_KEY);

        Promise.all(promises).then(responses => {
            let newState = {loading: false};

            let transactingPartnerConfigResponse = responses[transactingPartnerConfigIndex];
            if (transactingPartnerConfigResponse.errors) {
                ToastHelper.error(transactingPartnerConfigResponse);
            } else if (JSON.stringify(transactingPartnerConfigResponse) === '{}') {
                this.props.history.replace("/home");
            } else {
                newState.transactingPartnerConfig = transactingPartnerConfigResponse;
                newState.remittancePartnerDisplayValue = transactingPartnerConfigResponse["REMITTANCE_PARTNER_DISPLAY_VALUE"];
            }

            let isChatActiveResponse = responses[isChatActiveIndex];
            if (isChatActiveResponse.id) {
                if (isChatActiveResponse.value === 'true') {
                    newState.isChatActive = true;
                }
            }
            this.setState(newState)
        })
    }

    handleChange = (event, field) => {
        this.setState({
            [event.target.id]: event.target.value
        }, () => this.validateInputField(field));
    };

    validateInputField(field) {
        let self = this;
        let previousInvalidValidations = {...this.state.inValidFields};
        delete previousInvalidValidations[field];
        let previousValidValidations = {...this.state.validFields};
        previousValidValidations[field] = true;

        this.setState({
            inValidFields: previousInvalidValidations,
            validFields: previousValidValidations
        }, () => {

            let fieldValue = this.state[field].id === undefined ? this.state[field] : this.state[field].name;

            if (field === "collectionPin") {
                this.schema["collectionPin"] = yup.object().shape({
                    collectionPin: ValidationRule.getStringRule("Reference", true)
                });
            }

            if (field === "phoneNumber") {
                this.schema["phoneNumber"] = yup.object().shape({
                    phoneNumber: ValidationRule.getCellphoneNumberRule("Cellphone number", true)
                });
            }

            if (this.schema[field] !== undefined) {
                this.schema[field].validate({[field]: fieldValue}).catch(function (err) {

                    let previousInvalidValidations = {...self.state.inValidFields};
                    previousInvalidValidations[field] = err.message;
                    let previousValidValidations = {...self.state.validFields};
                    delete previousValidValidations[field];
                    self.setState({
                        inValidFields: previousInvalidValidations,
                        validFields: previousValidValidations
                    });
                })
            }
        })
    }

    hasBeenTouched(field) {

        let previousTouched = {...this.state.touchedFields};
        previousTouched[field] = true;
        this.setState({
                touchedFields: previousTouched
            }, () => this.validateInputField(field)
        );
    }

    goHome() {
        this.props.history.replace("/home");
    }

    retry() {
        this.setState({
            view: TRANSACTION_SEARCH,
            phoneNumber: "",
            collectionPin: ""
        });
    }

    searchTransaction() {

        this.setState({
            loading: true
        });

        InboundTransactionSearchService.findOrder(this.state.collectionPin, this.remittancePartner, this.state.phoneNumber).then(response => {
            if (response.transactionId) {
                if (response.isRegistered) {
                    this.setState({
                        loading: false,
                        phoneNumber: "",
                        collectionPin: "",
                        transactionData: response,
                        view: CUSTOMER_REGISTERED
                    });
                } else {
                    InboundTransactionService.isRedeemable(response.transactionId).then(redeemableResponse => {
                        if (redeemableResponse["error-code"]) {
                            ToastHelper.formatError(redeemableResponse);
                        } else {
                            if (redeemableResponse.redeemable === true) {
                                window.location = response.registrationUrl;
                            } else {
                                this.setState({
                                    loading: false,
                                    errorResponse: "NOT_REDEEMABLE",
                                    view: CANNOT_PROCESS_ORDER
                                });
                            }
                        }
                    })
                }
            } else {
                if (response["error-code"] === "ORDER_PROCESSING_ERROR") {
                    this.setState({
                        loading: false,
                        errorResponse: response,
                        view: CANNOT_PROCESS_ORDER
                    });
                } else {
                    ToastHelper.error("We were unable to process this order. Please contact our call center.")
                }
            }
        });
    }

    isSearchDisabled() {
        return this.state.loading || this.state.collectionPin === "" || this.state.phoneNumber === "" || this.state.inValidFields["phoneNumber"] !== undefined || this.state.inValidFields["collectionPin"] !== undefined;
    }

    onBackClick() {
        this.props.history.replace(this.baseUrl)
        this.setState({
            isContactUsShowing: false
        });
    }

    onToolTipOpen() {
        this.setState({
            toolTipOpen: true
        });
    }

    onToolTipClose() {
        this.setState({
            toolTipOpen: false
        });
    }

    onContactUsClick() {
        this.props.history.replace(this.baseUrl + "/contact-us")
        this.setState({
            isContactUsShowing: true
        });
    }

    showChat() {
        this.setState({
            isChatShowing: true
        });
    }

    render() {
        let className = this.props.isMobile ? "mobile" : "browser";
        if (this.state.loading) {
            return <div className={className + "_background_default_transaction_search"}>
                <SikhonaLoadingComponent/>
            </div>
        }

        return <Fragment>
            {this.renderContent(className)}
            {(!this.state.isContactUsShowing && !this.state.isFaded) && this.renderContactUs()}
            {this.state.isFaded && this.renderFadeOut()}
            {this.state.isContactUsShowing && this.renderContactUsForm()}
            {this.state.isChatActive && <Fragment>
                {this.state.createConversationError === "" ? <Fragment>
                        {this.renderChat()}
                    </Fragment>
                    :
                    <Fragment>
                        {this.renderCreateConversationError()}
                    </Fragment>
                }
                {this.state.viewConversationError === "" ? <Fragment>
                        {this.renderChat()}
                    </Fragment>
                    :
                    <Fragment>
                        {this.renderViewConversationError()}
                    </Fragment>
                }
            </Fragment>
            }
            {this.renderFooter()}
        </Fragment>

    }

    renderContent(className) {
        return <Fragment>

            <div className={className + "_background_default_transaction_search"}>
                <div className={"logo_header"}>
                    <br/>
                    <div className={"logo_img_container"}>
                        <img src={"/images/sikhona_logo_full_white.png"} alt={""}
                             className={"logo_img_sikhona"}/>
                    </div>
                    <div className={"logo_dividing_line"}/>
                    <div className={"logo_img_container"}>
                        <img src={"/images/WorldRemit_300ppi_white.png"} alt={""}
                             className={"logo_img_other"}/>
                    </div>
                </div>
                <div>
                    <div className={className + "_landing_page_detail_fields"} style={{zIndex: 2}}>
                        {this.state.loading ?
                            this.renderLoadingScreen()
                            :
                            <Fragment>
                                {!this.state.isContactUsShowing && (this.state.view === TRANSACTION_SEARCH && this.renderInputFields(className))}
                                {this.state.view === CUSTOMER_REGISTERED && this.renderCustomerRegistered(className)}
                                {this.state.view === CANNOT_PROCESS_ORDER && this.renderCannotProcessOrder(className)}
                            </Fragment>
                        }
                    </div>
                </div>
                {/*{this.state.isFaded &&*/}
                {/*<div>*/}
                {/*    <div className={"chat-bubble"}>*/}
                {/*        <span className={"bubble-content"}>Hi there! I'm Sikhona Sam, here to assist.</span>*/}
                {/*        <span className={"bubble-content bubble-1"}>If you need any assistance, please contact us via the WhatsApp or Call Center Phone Number links below.</span>*/}
                {/*        <span className={"bubble-content bubble-2"}>Otherwise, click here and send us an email.</span>*/}
                {/*    </div>*/}
                {/*    <img src={"./images/sikhona_sam_pose_wink_wave.png"} alt={""}*/}
                {/*         className={"sikhona_sam_img"}/>*/}
                {/*    <SFXButtonComponent className={"got_it_button"} onClick={() => this.setState({isFaded: false})}>Got*/}
                {/*        it</SFXButtonComponent>*/}
                {/*</div>*/}
                {/*}*/}
            </div>
        </Fragment>
    }

    renderContactUs() {
        return <div className={"contact-us-footer"}>
            <div className={"contact-us-link-container-10px"}>
                <b className={"contact-us-bold-text"}>Contact Us</b>
            </div>
            <div className={"contact-us-link-container-5px"}>
                <a href={"https://api.whatsapp.com/send?phone=27110738122"}>
                    <i className={"fa fa-whatsapp contact-us-link-icon"}/></a>
                <a href={"https://api.whatsapp.com/send?phone=27110738122"} className={"contact-us-link-text"}>011 073 8122</a>
            </div>
            <div className={"contact-us-link-container-5px"}>
                <a href={"tel:0861%20660%20660"}><i className={"fa fa-mobile  contact-us-link-icon"}/></a>
                <a href={"tel:0861%20660%20660"} className={"contact-us-link-text"}>0861 660 660</a>
            </div>
            <div className={"contact-us-link-container-10px"}>
                <span onClick={this.onContactUsClick.bind(this)}
                      className={"fa fa-envelope  contact-us-link-icon"}/>
                <span onClick={this.onContactUsClick.bind(this)}
                      className={"contact-us-link-text"}>{this.state.transactingPartnerConfig["EMAIL_ADDRESS"]}</span>
            </div>
        </div>
    }

    renderFooter() {
        return <Fragment>

            <div className={"inbound-transaction-search-footer"}>
                <div className={"footer-links-container"}>
                    <img src={"/images/wash_out_logo_S.png"} alt={""} className={"footer-logo"}/>
                    <div className={"footer-links-inner-container"}>
                        <a href={"riamoney.link/infaq"} target="_blank" rel="noopener noreferrer"
                           className={"footer-link"}>FAQS</a>
                        <a href={"https://riamoney.link/declaration"} target="_blank" rel="noopener noreferrer"
                           className={"footer-link"}>Declaration</a>
                        <a href={"https://riamoney.link/privacy"} target="_blank" rel="noopener noreferrer"
                           className={"footer-link"}>Privacy Policy</a>
                        <a href={"https://riamoney.link/tncs"} target="_blank"
                           rel="noopener noreferrer" className={"footer-link"}>Terms And Conditions</a>
                    </div>
                </div>
            </div>
        </Fragment>
    }

    renderInputFields(className) {

        return <Fragment>
            {/*uncomment for ad*/}
            {/*<div>*/}
            {/*    <img src={"/images/WRC_Img.png"} alt={""} className={"ad-button-image"}/>*/}
            {/*</div>*/}
            <Card className={"input-fields-card"}>
                <CardBody>
                    <br/>
                    {this.renderInput(className, "Reference", "collectionPin", "search")}
                    <br/>
                    {this.renderInput(className, "Cellphone Number", "phoneNumber", "phone")}

                    {this.renderSearchButton("Search", className)}
                </CardBody>
            </Card>
        </Fragment>
    }

    renderInput(className, text, field, icon) {
        let helpText = "Please type in your reference number that you have received from " + this.state.remittancePartnerDisplayValue;

        if (field === "phoneNumber") {
            helpText = "If you have previously registered with us, please enter the cellphone number you registered with. If not, please enter your cellphone number."
        }

        return <div className={"landing-page-input-container"}>
            <div className={"landing-page-input"}>
                <i className={"landing-page-input-icon fa fa-" + icon}/>
                <Input className={"landing-page-input-text"}
                       required
                       type={"text"}
                       value={this.state[field]}
                       placeholder={text}
                       id={field}
                       onChange={(event) => this.handleChange(event, field)}
                       onBlur={() => this.hasBeenTouched(field)}
                />

                <Fragment>
                    <div className={"circle-question-container"} title={helpText}
                         onClick={this.onToolTipClose.bind(this)}>
                        <i className={"fa fa-question circle-question"}/>
                    </div>
                </Fragment>

            </div>
            <div>
                {this.state.touchedFields[field] && this.state.inValidFields[field] && this.renderErrorMessage(className, field)}
            </div>
        </div>

    }

    renderFadeOut() {
        return <Fragment>
            <div className={"fade"}/>
        </Fragment>
    }

    renderCustomerRegistered(className) {
        return <Fragment>
            <div style={{
                marginTop: "12vh",
                color: "white",
                fontSize: "2vh"
            }}>
                <span style={{textAlign: "center", fontWeight: "bold"}}>{"Thank you."}</span>
                <br/>
                <br/>
                <span>{"Your transaction has been found and will be processed. You will receive your cash collection voucher soon."}</span>
                <br/>
                <br/>
                <span>{"For any further information, please don't hesitate to contact us."}</span>
            </div>
        </Fragment>
    }

    renderCannotProcessOrder(className) {
        if (this.state.errorResponse.message === "ALLOCATED") {
            return this.renderOrderAllocated(className);
        } else if (this.state.errorResponse.message === "COMPLETE") {
            return this.renderOrderComplete(className);
        } else if (this.state.errorResponse.message === "REJECTED") {
            return this.renderOrderRejected(className);
        } else if (this.state.errorResponse === "NOT_REDEEMABLE") {
            return this.renderOrderNotRedeemable(className);
        } else {
            return this.renderOrderNotFound(className)
        }
    }

    renderOrderRejected(className) {
        return <Fragment>
            <div style={{
                marginTop: "12vh",
                color: "white",
                fontSize: "2vh"
            }}>
                <span>{"We have found an issue with your transaction."}</span>
                <br/>
                <br/>
                <span>{"Please contact us and one of our consultants will assist you."}</span>
                {this.renderRetryButton("Retry", className)}
            </div>
        </Fragment>
    }

    renderOrderComplete(className) {
        return <Fragment>
            <div style={{
                marginTop: "12vh",
                color: "white",
                fontSize: "2vh"
            }}>
                <span>{"This transaction reference number "}</span>
                <b>{this.state.collectionPin}</b>
                <span>{" has already been redeemed."}</span>
                <br/>
                <br/>
                <span>{"Please contact us and one of our consultants will assist you."}</span>
                {this.renderRetryButton("Retry", className)}
            </div>
        </Fragment>
    }

    renderOrderNotRedeemable(className) {
        return <Fragment>
            <div style={{
                marginTop: "12vh",
                color: "white",
                fontSize: "2vh"
            }}>
                <span>{"This transaction reference number "}</span>
                <b>{this.state.collectionPin}</b>
                <span>{" cannot be redeemed."}</span>
                <br/>
                <br/>
                <span>{"Please contact us and one of our consultants will assist you."}</span>
                {this.renderRetryButton("Retry", className)}
            </div>
        </Fragment>
    }

    renderOrderAllocated(className) {
        return <Fragment>
            <div style={{
                marginTop: "12vh",
                color: "white",
                fontSize: "2vh"
            }}>
                <span>{"This transaction reference number "}</span>
                <b>{this.state.collectionPin}</b>
                <span>{" has already been allocated and is being processed."}</span>
                <br/>
                <br/>
                <span>{"Please contact us and one of our consultants will assist you."}</span>
                {this.renderRetryButton("Retry", className)}
            </div>
        </Fragment>
    }

    renderOrderNotFound(className) {
        return <Fragment>
            <div style={{
                marginTop: "12vh",
                color: "white",
                fontSize: "2vh"
            }}>
                <span>{"Your transaction reference number "}</span>
                <b>{this.state.collectionPin}</b>
                <span>{" could not be found."}</span>
                <br/>
                <br/>
                <span>{"Please either try again or contact your sender to ensure they have given you the correct number."}</span>
                {this.renderRetryButton("Retry", className)}
            </div>
        </Fragment>
    }

    renderSearchButton(buttonText, className) {
        return <div className={className + "_register_button_div"} style={{marginTop: "35px"}}>
            <SFXButtonComponent
                className={className + "_register_button search-button"}
                onClick={this.searchTransaction}
                disabled={this.isSearchDisabled()}
            >{buttonText}
            </SFXButtonComponent>
        </div>
    }

    renderGoHomeButton(buttonText, className) {
        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_register_button search-button"}
                onClick={this.goHome}
            >{buttonText}
            </SFXButtonComponent>
        </div>
    }

    renderRetryButton(buttonText, className) {
        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_register_button search-button"}
                onClick={this.retry}
            >{buttonText}
            </SFXButtonComponent>
        </div>
    }

    renderErrorMessage(className, field) {
        return <h6 className={"error-message-landing-page"}>
            {this.state.inValidFields[field]}
        </h6>;
    }

    renderLoadingScreen() {
        return <Fragment>
            <div style={{position: "relative", top: "18vh"}}>
                <SikhonaLoadingComponent/>
            </div>
        </Fragment>
    }

    renderContactUsForm() {
        return <InboundTransactionSearchContactUs
            onBackClick={this.onBackClick.bind(this)}
            baseUrl={this.baseUrl + "/contact-us"}
            isMobile={this.props.isMobile}
            transactingPartnerConfig={this.state.transactingPartnerConfig}
        />
    }

    renderChat() {
        return <ChatComponent
            customType={this.state.remittancePartnerDisplayValue + ' Chat'}
            context={[]}
            onConversationFailedToCreate={(error) => {
                this.setState({
                    createConversationError: error.errors
                });
            }}
            onFailedToLoadUser={(error) => {
                this.setState({
                    viewConversationError: error.errors
                });
            }}
        />
    }

    renderCreateConversationError() {
        return <Fragment>
            <div className={"error-pop-up"}>
                <span>{"There was an issue connecting you to a consultant."}</span>
                <br/>
                <span>{"Please refresh and try again."}</span>
            </div>
        </Fragment>
    }

    renderViewConversationError() {
        return <Fragment>
            <div className={"error-pop-up"}>
                <span>{"There was an issue connecting you to a consultant."}</span>
                <br/>
                <span>{"Please refresh and try again."}</span>
            </div>
        </Fragment>
    }
}

export default withRouter(InboundTransactionSearch);
